import { render, staticRenderFns } from "./NotPatientSelectedMessage.template.vue?vue&type=template&id=0e1f48ef&scoped=true&"
var script = {}
import style0 from "./NotPatientSelectedMessage.template.vue?vue&type=style&index=0&id=0e1f48ef&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1f48ef",
  null
  
)

export default component.exports